export default "__VITE_ASSET__ByobcJtU__"